import React from "react";
import { Chip, FormControl, InputLabel, Select, Typography } from "@mui/material";
import { DATE_CHIPS_HEADER, DATE_SELECT_HEADER } from "../UserVisibleStrings";

type DateChipsProps = {
    dates: Array<Date | undefined>,
    selectedDates: Set<number>,
    onDateSelect: ( dateValue: Date, isShiftClick: boolean ) => void,
    onClearSelection: React.Dispatch<React.SetStateAction<Set<number>>>,
};

const DateChips: React.FC<DateChipsProps> = ( { dates, selectedDates, onDateSelect, onClearSelection } ) =>
{
    const getChipStyle = ( isAllChip: boolean, dateValue?: Date ) =>
    {
        if ( isAllChip )
        {
            return {
                margin: "4px",
                backgroundColor: selectedDates.size === 0 ? "#1976d2" : "#e0e0e0",
                color: selectedDates.size === 0 ? "#fff" : "#000",
                fontSize: "12px",
            };
        }

        if ( dateValue )
        {
            const isSelected = selectedDates.has( dateValue?.getTime() );
            return {
                margin: "4px",
                backgroundColor: isSelected ? "#1976d2" : "#e0e0e0",
                color: isSelected ? "#fff" : "#000",
                fontSize: "12px"
            };
        }
    };

    if ( dates.length > 15 )
    {
        const dateArray = Array.from( selectedDates.values() ).map( date => new Date( date ).toLocaleDateString( "en-US", { month: "short", day: "numeric" } ) );
        if ( dateArray.length === 0 )
        {
            dateArray.push( "All" );
        }
        return (
            <FormControl fullWidth>
                <InputLabel>{DATE_SELECT_HEADER}</InputLabel>
                <Select
                    multiple
                    value = {dateArray}
                    label = "Date"
                    MenuProps = {{
                        style: { width: "300px" },
                    }}
                    renderValue = {( selected ) =>
                    {
                        return selected.map( date => date ).join( ", " );
                    }}
                >
                    <Chip
                        label = "All"
                        style = {getChipStyle( true )}
                        onClick = {() => onClearSelection( new Set<number>() )}
                    />
                    {dates.map( ( date ) =>
                    {
                        const dateValue = date;
                        return dateValue !== undefined ? (
                            <Chip
                                key = {dateValue.toString()}
                                label = {dateValue.toLocaleDateString( "en-US", { month: "short", day: "numeric" } )}
                                style = {getChipStyle( false, dateValue )}
                                onClick = {( event ) => onDateSelect( dateValue, event.shiftKey )}
                            />
                        ) : null;
                    } )}
                </Select>
            </FormControl>
        );
    }

    return (
        <div style = {{ textAlign: "center" }}>
            <Typography variant = "h5" component = "div" sx = {{ fontSize: "18px" }}>
                {DATE_CHIPS_HEADER}
            </Typography>
            <div style = {{ display: "flex", flexWrap: "wrap", justifyContent: "center", }}>
                <Chip
                    label = "All"
                    size = "small"
                    style = {getChipStyle( true )}
                    onClick = {() => onClearSelection( new Set<number>() )}
                />
                {dates.map( ( date, index ) => date !== undefined ? (
                    <Chip
                        key = {date.toString()}
                        label = {`Day ${index + 1}`}
                        size = "small"
                        style = {getChipStyle( false, date )}
                        onClick = {( event ) => onDateSelect( date, event.shiftKey )}
                    />
                ) : null )}
            </div>
        </div>
    );
};

export default DateChips;
